import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography,
    makeStyles
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeAddBidDialog } from "./bids-add-slice";
import { db, storage } from "../../../../firebase";
import { useState } from "react";
import { addBidService } from "./bids-add-service";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from 'moment';
import { ref } from "firebase/storage";
import { showWarningSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        background:"#111111",
    },
    text: {
        color: "#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
    current_bid: 0,
    status: "",
    latest_bidder: "",
};

const BidsAdd = () => {
    const classes = useStyles();
    const showDialog = useSelector((state) => state.bidsAddSlice.showDialog);
    const isLoading = useSelector((state) => state.bidsAddSlice.isLoading);
    const [formData, setFormData ] = useState(initiaFormData);
    const [dateStart, setDateStart] = useState(null);
    const [dateEnd, setDateEnd] = useState(null);
    const [file, setFile] = useState(null);
    const dispatch = useDispatch();

    // handle input
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
    };

    // handle file input
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile(selectedFile);
        } else {
          dispatch(showWarningSnackbar('Please select a file.'));
        }
    };

    // handle date start
    const handleDateStartChange = (newValue) => {
        if (newValue) {
            const selectedate = moment(newValue).startOf('day');
            setDateStart(selectedate.toString());
        }
    };

    // handle date end
    const handleDateEndChange = (newValue) => {
        if (newValue) {
            const selectedate = moment(newValue).startOf('day');
            setDateEnd(selectedate.toString());
        }
    };

    // handle add
    const handleAddSubmit = async (e) => {
        e.preventDefault();  
       
        try {
            if (file) {
                const timestamp = Date.now();
                const uniqueFileName = `${timestamp}_${file.name}`;
                const storageRef = ref(storage, `/images/${uniqueFileName}`);

                const new_data = {
                    ...formData,
                    date_start: dateStart,
                    date_end: dateEnd,
                };
                await addBidService(dispatch, db, "bids", new_data, storageRef, file);
            }
          } catch (e) {
            console.error("Error adding document: ", e);
          }
        handleAddClose();
    };

    // handle close add
    const handleAddClose = () => {
        setFormData(initiaFormData);
        dispatch(closeAddBidDialog());
    };

    console.log("formData: ", formData);
          
    return (
        <Dialog
            open={showDialog}
        >
            <DialogTitle className={classes.title}>
                Add Bid Item
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                            id="image-input"
                        />
                        <label htmlFor="image-input">
                            <Button
                            variant="outlined"
                            component="span"
                            className={classes.button}
                            >
                                Upload Image
                            </Button>
                            {
                                formData.image?.name && (
                                    formData.image.name
                                )
                            }
                        </label>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Code"
                            variant="filled"
                            fullWidth
                            name="code"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Name"
                            variant="filled"
                            fullWidth
                            name="name"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="filled-basic"
                            label="Description"
                            variant="filled"
                            fullWidth
                            name="description"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                variant="filled"
                                label="Date Start"
                                openTo="year"
                                views={["year", "month", "day"]}
                                fullWidth
                                name="date_start"
                                // value={datePickup}
                                onChange={handleDateStartChange}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                variant="filled"
                                label="Date End"
                                openTo="year"
                                views={["year", "month", "day"]}
                                fullWidth
                                name="date_end"
                                // value={datePickup}
                                onChange={handleDateEndChange}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Starting Bid"
                            variant="filled"
                            fullWidth
                            name="current_bid"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Final Bid"
                            variant="filled"
                            fullWidth
                            name="final_bid"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Status"
                            variant="filled"
                            fullWidth
                            name="status"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Latest Bidder"
                            variant="filled"
                            fullWidth
                            name="latest_bidder"
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleAddSubmit}
                    disabled={isLoading}
                >
                    {
                        isLoading ? (
                            "Adding..."
                        ) : (
                            "Add"
                        )
                    }
                </Button>
                <Button
                    variant="text"
                    className={classes.buttonText}
                    onClick={handleAddClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BidsAdd;